<div class="main notification">
    <div class="main-title with-badges">
        <div>
            <h1>Notifications</h1>
            <p class="subtitle">Tap a notification to view details</p>
        </div>
        <div class="badges" *ngIf="!loading">
            <span class="badge badge-unread" *ngIf="unreadNotification > 0"
                >{{ unreadNotification }} unread</span
            >
            <span class="badge badge-high" *ngIf="highPriorityNotication > 0"
                >{{ highPriorityNotication }} high</span
            >
            <span
                class="badge badge-action"
                *ngIf="actionRequiredNotification > 0"
                >{{ actionRequiredNotification }} action</span
            >
        </div>
    </div>

    <div class="cards" *ngIf="data?.length; else emptyState">
        <div
            class="card notification-card"
            *ngFor="let item of data; trackBy: trackById"
            [class.unread]="!item.isRead"
            (click)="openNotification(item)"
        >
            <div class="left">
                <span class="indicator" [class.unread]="!item.isRead"></span>
                <div class="title" [innerHTML]="item.title"></div>
                <div class="meta">
                    <span class="location">{{ getLocationLine(item) }}</span>
                    <span class="dot">•</span>
                    <span class="time">{{
                        calculateTimeAgo(item.dateTime)
                    }}</span>
                </div>
            </div>
            <div class="right">
                <span
                    class="priority"
                    [ngClass]="item.priority.toLowerCase()"
                    >{{ item.priority }}</span
                >
            </div>
        </div>
    </div>

    <ng-template #emptyState>
        <div class="empty">
            <i class="fas fa-bell-slash"></i>
            <p>No notifications yet</p>
        </div>
    </ng-template>

    <p-paginator
        *ngIf="data?.length"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
    ></p-paginator>
</div>
<p-dialog
    [(visible)]="displayNotification"
    modal="true"
    [style]="{width: '600px'}"
    [closable]="false"
>
    <!-- <div class="text-left" (click)="closeDialog()"> <span class="fas fa-chevron-left"></span> Back</div> -->
    <h5>Notification</h5>
    <ng-template pTemplate="content">
        <div class="notification-detail">
            <div class="title" [innerHTML]="notificationDetail?.title"></div>
            <div class="meta">
                <span>{{
                    notificationDetail &&
                        calculateTimeAgo(notificationDetail.dateTime)
                }}</span>
                <span class="dot">•</span>
                <span>{{ notificationDetail?.sensorName }}</span>
            </div>
            <div class="location" *ngIf="notificationDetail">
                {{ getLocationLine(notificationDetail) }}
            </div>
            <div
                class="description"
                [innerHTML]="notificationDetail?.description"
            ></div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button
            type="button"
            class="btn btn-secondary mr-2"
            (click)="closePopup()"
        >
            Close
        </button>
    </ng-template>
</p-dialog>
